/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  UserSearch,
  ErrorInfo,
  UserSearchConditions,
  PostUsersTakeoverBody,
  BinaryFile,
  PostUsersDeleteBody,
  UserDetail,
  PostUsersDetailBody,
  UserMailNotifications,
  GetUsersUsers200,
  UserPassword
} from '.././model'


/**
 * ユーザーテーブルからマスタ一覧を取得して返す。

 * @summary ユーザー検索
 */
export const postUsersSearch = (
    userSearchConditions: UserSearchConditions, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserSearch>> => {
    return axios.post(
      `/users/search`,
      userSearchConditions,options
    );
  }



    export type PostUsersSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postUsersSearch>>>
    export type PostUsersSearchMutationBody = UserSearchConditions
    export type PostUsersSearchMutationError = AxiosError<ErrorInfo>

    export const usePostUsersSearch = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersSearch>>, TError,{data: UserSearchConditions}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsersSearch>>, {data: UserSearchConditions}> = (props) => {
          const {data} = props ?? {};

          return  postUsersSearch(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postUsersSearch>>, TError, {data: UserSearchConditions}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 引継ぎ元のユーザーIDを引継ぎ先のユーザーIDに変更する。

 * @summary ユーザー引継ぎ
 */
export const postUsersTakeover = (
    postUsersTakeoverBody: PostUsersTakeoverBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    return axios.post(
      `/users/takeover`,
      postUsersTakeoverBody,options
    );
  }



    export type PostUsersTakeoverMutationResult = NonNullable<Awaited<ReturnType<typeof postUsersTakeover>>>
    export type PostUsersTakeoverMutationBody = PostUsersTakeoverBody
    export type PostUsersTakeoverMutationError = AxiosError<ErrorInfo>

    export const usePostUsersTakeover = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersTakeover>>, TError,{data: PostUsersTakeoverBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsersTakeover>>, {data: PostUsersTakeoverBody}> = (props) => {
          const {data} = props ?? {};

          return  postUsersTakeover(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postUsersTakeover>>, TError, {data: PostUsersTakeoverBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * システムに登録しているすべてのユーザー情報をExcelでダウンロード

 * @summary ユーザー情報ダウンロード
 */
export const postUsersDownload = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/users/download`,undefined,options
    );
  }



    export type PostUsersDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postUsersDownload>>>
    
    export type PostUsersDownloadMutationError = AxiosError<ErrorInfo>

    export const usePostUsersDownload = <TError = AxiosError<ErrorInfo>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersDownload>>, TError,TVariables, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsersDownload>>, TVariables> = () => {
          

          return  postUsersDownload(axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postUsersDownload>>, TError, TVariables, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ユーザーを削除する

 * @summary ユーザー削除
 */
export const postUsersDelete = (
    postUsersDeleteBody: PostUsersDeleteBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    return axios.post(
      `/users/delete`,
      postUsersDeleteBody,options
    );
  }



    export type PostUsersDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postUsersDelete>>>
    export type PostUsersDeleteMutationBody = PostUsersDeleteBody
    export type PostUsersDeleteMutationError = AxiosError<ErrorInfo>

    export const usePostUsersDelete = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersDelete>>, TError,{data: PostUsersDeleteBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsersDelete>>, {data: PostUsersDeleteBody}> = (props) => {
          const {data} = props ?? {};

          return  postUsersDelete(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postUsersDelete>>, TError, {data: PostUsersDeleteBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ユーザー情報1件表示

 * @summary ユーザー情報1件表示
 */
export const postUsersDetail = (
    postUsersDetailBody: PostUsersDetailBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserDetail>> => {
    return axios.post(
      `/users/detail`,
      postUsersDetailBody,options
    );
  }



    export type PostUsersDetailMutationResult = NonNullable<Awaited<ReturnType<typeof postUsersDetail>>>
    export type PostUsersDetailMutationBody = PostUsersDetailBody
    export type PostUsersDetailMutationError = AxiosError<ErrorInfo>

    export const usePostUsersDetail = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersDetail>>, TError,{data: PostUsersDetailBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsersDetail>>, {data: PostUsersDetailBody}> = (props) => {
          const {data} = props ?? {};

          return  postUsersDetail(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postUsersDetail>>, TError, {data: PostUsersDetailBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ユーザー情報1件表示 | UserDetail.user_id = null の場合、新規追加

 * @summary ユーザー情報更新
 */
export const postUsersSave = (
    userDetail: UserDetail, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserDetail>> => {
    return axios.post(
      `/users/save`,
      userDetail,options
    );
  }



    export type PostUsersSaveMutationResult = NonNullable<Awaited<ReturnType<typeof postUsersSave>>>
    export type PostUsersSaveMutationBody = UserDetail
    export type PostUsersSaveMutationError = AxiosError<ErrorInfo>

    export const usePostUsersSave = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersSave>>, TError,{data: UserDetail}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsersSave>>, {data: UserDetail}> = (props) => {
          const {data} = props ?? {};

          return  postUsersSave(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postUsersSave>>, TError, {data: UserDetail}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * メール通知設定

 * @summary メール通知設定
 */
export const postUsersNotification = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserMailNotifications>> => {
    return axios.get(
      `/users/notification`,options
    );
  }


export const getPostUsersNotificationQueryKey = () => [`/users/notification`];

    
export type PostUsersNotificationQueryResult = NonNullable<Awaited<ReturnType<typeof postUsersNotification>>>
export type PostUsersNotificationQueryError = AxiosError<ErrorInfo>

export const usePostUsersNotification = <TData = Awaited<ReturnType<typeof postUsersNotification>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof postUsersNotification>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPostUsersNotificationQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof postUsersNotification>>> = ({ signal }) => postUsersNotification({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof postUsersNotification>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * ユーザー一覧取得

 * @summary ユーザー一覧取得
 */
export const getUsersUsers = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUsersUsers200>> => {
    return axios.get(
      `/users/users`,options
    );
  }


export const getGetUsersUsersQueryKey = () => [`/users/users`];

    
export type GetUsersUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersUsers>>>
export type GetUsersUsersQueryError = AxiosError<ErrorInfo>

export const useGetUsersUsers = <TData = Awaited<ReturnType<typeof getUsersUsers>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUsersUsers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUsersUsersQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersUsers>>> = ({ signal }) => getUsersUsers({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getUsersUsers>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * パスワード変更

 * @summary パスワード変更
 */
export const postUsersPassword = (
    userPassword: UserPassword, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/users/password`,
      userPassword,options
    );
  }



    export type PostUsersPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postUsersPassword>>>
    export type PostUsersPasswordMutationBody = UserPassword
    export type PostUsersPasswordMutationError = AxiosError<ErrorInfo>

    export const usePostUsersPassword = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersPassword>>, TError,{data: UserPassword}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsersPassword>>, {data: UserPassword}> = (props) => {
          const {data} = props ?? {};

          return  postUsersPassword(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postUsersPassword>>, TError, {data: UserPassword}, TContext>(mutationFn, mutationOptions)
    }
    